import { CustomerFunnelModule } from '@korint/folio';
import { usePolicyControllerConfirmPolicy } from 'korint-sdk';
import type { Field, FormSectionsWithShortcuts } from 'korint-sdk/react';

const personTypeFields: Array<Field> = [
  {
    name: 'legalNaturalPerson',
    type: 'radio',
    options: [
      { label: 'Personne physique', value: 'NATURAL_PERSON' },
      { label: 'Personne morale', value: 'LEGAL_PERSON' },
    ],
    isCustomField: true,
    required: true,
  },
];

const naturalPersonFields: Array<Field> = [
  // {
  //   name: 'title',
  //   label: 'Civilité',
  //   type: 'radio',
  //   options: [
  //     { label: 'Monsieur', value: 'M' },
  //     { label: 'Madame', value: 'Mme' },
  //     { label: 'Autre', value: 'Autre' },
  //   ],
  //   isCustomField: true,
  //   required: true,
  // },
  {
    name: 'firstName',
    type: 'text',
    isCustomField: true,
    required: true,
  },
  {
    name: 'lastName',
    type: 'text',
    isCustomField: true,
    required: true,
  },
  {
    name: 'email',
    type: 'email',
    isCustomField: true,
    required: true,
  },
  {
    name: 'phoneNumber',
    type: 'phoneNumber',
    isCustomField: true,
    required: true,
  },
  {
    name: 'address',
    type: 'address',
    isCustomField: true,
    required: true,
  },
  {
    name: 'postCode',
    type: 'postcode',
    isCustomField: true,
    required: true,
  },
  {
    name: 'city',
    type: 'city',
    isCustomField: true,
    required: true,
  },
];

const sirenSearch: Field = {
  name: 'siret',
  required: true,
  type: 'company',
  apiDataAccessor: 'companyInfo',
  formDataAccessor: 'siret.siret',
  isCustomField: true,
};

const sections = [
  {
    title: 'Titulaire du contrat',
    fields: personTypeFields,
  },
  {
    fields: naturalPersonFields,
    showWhen: [
      {
        fieldName: 'legalNaturalPerson',
        condition: 'equals',
        value: 'NATURAL_PERSON',
      },
    ],
  },
  {
    fields: [sirenSearch, ...naturalPersonFields],
    showWhen: [
      {
        fieldName: 'legalNaturalPerson',
        condition: 'equals',
        value: 'LEGAL_PERSON',
      },
    ],
  },
] as const satisfies FormSectionsWithShortcuts;

export function PolicyFunnelPolicyHolder() {
  const { mutateAsync: confirmPolicy } = usePolicyControllerConfirmPolicy();

  return (
    <CustomerFunnelModule
      sections={sections}
      path="policyholder"
      afterSubmit={async (_data, { policyId, branchId }) => {
        await confirmPolicy({ policyId, params: { branchId } });
      }}
    />
  );
}
